<div class="h-full flex flex-col">
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-800">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">Campos</h3>
    <p class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">Arrastra o haz clic para añadir</p>
  </div>

  <div
    cdkDropList
    id="palette-list"
    [cdkDropListData]="allFields"
    [cdkDropListSortingDisabled]="true"
    cdkDropListConnectedTo="canvas-list"
    class="flex-1 overflow-y-auto px-3 py-3 space-y-4"
  >
    @for (group of groups; track group.label) {
      <div>
        <p class="text-[10px] font-semibold uppercase tracking-widest text-gray-400 dark:text-gray-500 px-1 mb-1.5">
          {{ group.label }}
        </p>
        <div class="space-y-1">
          @for (field of group.fields; track field.type) {
            @if (isDisabled(field.type)) {
              <div
                class="flex items-center gap-2.5 px-3 py-2.5 rounded-xl border border-gray-100 dark:border-gray-800 bg-gray-50 dark:bg-gray-900/50 cursor-not-allowed select-none opacity-50"
                [title]="'Ya hay un campo ' + field.label + ' en el formulario'"
              >
                <span class="w-4 h-4 flex-shrink-0 [&>svg]:w-full [&>svg]:h-full [&>svg]:block text-gray-300 dark:text-gray-600" [innerHTML]="field.icon | safeHtml"></span>
                <span class="text-xs font-medium text-gray-400 dark:text-gray-600 flex-1">{{ field.label }}</span>
                <span class="text-[10px] font-medium text-gray-400 dark:text-gray-600 bg-gray-100 dark:bg-gray-800 rounded px-1.5 py-0.5 leading-none flex-shrink-0">Ya añadido</span>
              </div>
            } @else {
              <div
                cdkDrag
                [cdkDragData]="field"
                (click)="addField.emit(field.type)"
                class="flex items-center gap-2.5 px-3 py-2.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 cursor-grab hover:border-brand-300 dark:hover:border-brand-500/50 hover:bg-brand-50 dark:hover:bg-brand-500/5 transition-all select-none group"
              >
                <span class="w-4 h-4 flex-shrink-0 [&>svg]:w-full [&>svg]:h-full [&>svg]:block text-gray-400 group-hover:text-brand-500 transition-colors" [innerHTML]="field.icon | safeHtml"></span>
                <span class="text-xs font-medium text-gray-700 dark:text-gray-300 group-hover:text-brand-600 dark:group-hover:text-brand-400 transition-colors">{{ field.label }}</span>

                <!-- Drag preview -->
                <div *cdkDragPreview class="flex items-center gap-2 px-3 py-2 rounded-xl bg-white dark:bg-gray-800 border border-brand-300 shadow-lg text-xs font-medium text-gray-700 dark:text-gray-200">
                  <span class="w-4 h-4 [&>svg]:w-full [&>svg]:h-full [&>svg]:block text-brand-500" [innerHTML]="field.icon | safeHtml"></span>
                  {{ field.label }}
                </div>

                <!-- Drag placeholder -->
                <div *cdkDragPlaceholder class="h-9 rounded-xl bg-brand-50 dark:bg-brand-500/10 border border-dashed border-brand-300 dark:border-brand-500/40"></div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
